export default function getIsoTimestamp() {
  return new Date().toISOString();
}
